import type { Dispatch } from 'redux';
import { connect, useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import { useUnmount } from 'react-use';

import { ITableRenderCell } from 'CorePackage/TableModule/interfaces/ITableRenderCell';
import { KnmVersionsEnum } from 'APIPackage/KnmModule/enums/KnmVersionsEnum';
import { ROUTE_KNM } from 'CorePackage/MainModule/routes/routes';
import { RootActions } from 'CorePackage/MainModule/types/RootActions';
import { ISimilarityMatch } from 'APIPackage/SimilarityModule/interfaces/ISimilarityMatch';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { getKnmListFindData } from 'KnmListPackage/MainModule/selectors/knmListSelectors';
import { IKnmIndex } from 'APIPackage/KnmModule/interfaces/IKnmIndex';
import { knmListFindKnm, knmListSetFindData } from 'KnmListPackage/MainModule/actions/knmListActions';

interface ISimilaritiesByPersonErpIdCellStoreProps {
  knms: IKnmIndex[];
}

function SimilaritiesByPersonErpIdCellWithoutStore({
  row,
  isErknm,
  knms,
}: ITableRenderCell<ISimilarityMatch> & ISimilaritiesByPersonErpIdCellStoreProps) {
  const [isFounded, setIsFounded] = useState(false);
  const dispatch = useDispatch<Dispatch<RootActions>>();
  const handleClickErpId = (erpId: string) => () => {
    const { ERP, ERKNM } = KnmVersionsEnum;

    setIsFounded(true);
    dispatch(knmListFindKnm({ searchString: erpId, version: isErknm ? ERKNM : ERP }, 1));
  };

  useEffect(() => {
    if (isFounded) {
      if (knms[0]?.id) {
        window.location.replace(ROUTE_KNM(knms[0].id));
      }
    }
  }, [dispatch, isFounded, knms]);

  useUnmount(() => {
    setIsFounded(false);
    dispatch(knmListSetFindData([]));
  });

  return (
    <a className="shared-table-link" onClick={handleClickErpId(row.erpId)} target="_blank" rel="noopener noreferrer">
      {row.erpId}
    </a>
  );
}

const mapStateToProps = (state: IRootState): ISimilaritiesByPersonErpIdCellStoreProps => ({
  knms: getKnmListFindData(state),
});

export const SimilaritiesByPersonErpIdCell = connect(mapStateToProps)(SimilaritiesByPersonErpIdCellWithoutStore);
